import React, { useEffect, useState } from "react";
import { t } from "ttag";

import { WebPageURL } from "../../models/nominals";
import { trackSleepExpertEvent } from "../../utils/analytics";
import { getChatConnector } from "../../utils/chatConnector";
import { navigateToURL } from "../../utils/urls";
import { Link } from "../Link";

interface IProps {
    className?: string;
    chatOnlineText?: string | React.ReactNode;
    chatOfflineText?: string | React.ReactNode;
    hideIfOffline?: boolean;
    chatOfflineLink: WebPageURL;
}

export const ChatLink = (props: IProps): React.ReactNode => {
    const [isChatOnline, setIsChatOnline] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const initializeChat = async () => {
            try {
                const { isOnline } = await getChatConnector().init();
                if (isMounted) {
                    setIsChatOnline(isOnline);
                }
            } catch (e) {
                console.error(e);
            }
        };

        initializeChat();

        return () => {
            isMounted = false;
        };
    }, []);

    const onClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        if (isChatOnline) {
            getChatConnector().openChat();
            trackSleepExpertEvent("chat");
        } else {
            navigateToURL(props.chatOfflineLink);
        }
    };

    if (isChatOnline) {
        return (
            <button className={props.className} onClick={onClick}>
                {props.chatOnlineText || t`Chat`}
            </button>
        );
    }
    if (props.hideIfOffline) {
        return null;
    }
    return (
        <Link className={props.className} href={props.chatOfflineLink}>
            {props.chatOfflineText || t`Contact Us`}
        </Link>
    );
};
